import { useEffect, useRef, useState } from 'react'

export const FOOTER_LOADING_SHOW_DELAY_MS = 150
export const FOOTER_LOADING_MIN_VISIBLE_MS = 600
export const FOOTER_LOADING_HIDE_DELAY_MS = 200

export function useFooterLoading(busy: boolean) {
  const [loading, setLoading] = useState(false)
  const shownAtRef = useRef<number | null>(null)

  useEffect(() => {
    const delay =
      busy || shownAtRef.current === null
        ? FOOTER_LOADING_SHOW_DELAY_MS
        : Math.max(
            FOOTER_LOADING_HIDE_DELAY_MS,
            FOOTER_LOADING_MIN_VISIBLE_MS - (Date.now() - shownAtRef.current),
          )
    const timer = setTimeout(() => {
      if (busy) {
        shownAtRef.current ??= Date.now()
      } else {
        shownAtRef.current = null
      }

      setLoading(busy)
    }, delay)

    return () => clearTimeout(timer)
  }, [busy])

  return loading
}
